// Hero.jsx
import { Link } from 'react-scroll';
import { FaChevronDown } from 'react-icons/fa';

export const Hero = () => {

  
  return (
    <section
    style={{ backgroundImage: 'url(/hero-yacht.jpg)', 
      backgroundSize: 'cover',
    backgroundPosition: 'top',
    }}
     className="pt-15 pb-15 bg-cover bg-center h-screen">
      <div className="bg-black bg-opacity-35 mx-auto h-screen">
        <div className='mx-5 md:mx-auto h-screen max-w-7xl'>

        <div className="text-center flex flex-col items-center justify-center h-[80vh]">
          <h1 className="text-2xl text-white md:text-5xl font-semibold mb-6">
          Empowering Your Path to Prosperity
          </h1>
          <h5 className="text-sm md:text-xl text-gray-100 mb-8 mx-6">
          Commitment to your goals with tailored advice and world-class expertise          
          </h5>
          <div className='justify-center items-center'>
          
          <Link className=' text-white absolute bottom-[10%] right-[10%] py-3 rounded-lg animate-bounce'
           to="about" smooth={true} duration={500}>
<FaChevronDown size={40} color="#fff" />      
</Link>
          </div>

        </div>
             </div>
      </div>
    </section>
  );
};